"use client";

import { useImageStore } from "@/stores/imageStore";

interface ModalDeleteImageProps {
  isOpen: boolean;
  onClose: () => void;
  imageId: string | null;
  onComplete: () => void;
}

export default function ModalDeleteImage({
  isOpen,
  onClose,
  imageId,
}: ModalDeleteImageProps) {
  const { remove, isDeleting } = useImageStore();

  const handleConfirm = async () => {
    if (!imageId) return;
    const ok = await remove(imageId);
    if (ok) onClose();
  };

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/40">
      <div className="bg-white rounded-lg shadow-lg w-full max-w-md mx-4">
        <div className="px-6 py-4 border-b border-gray-200">
          <h2 className="text-lg font-semibold">Xác nhận xóa ảnh</h2>
        </div>
        <div className="px-6 py-4">
          <p>
            Bạn có chắc chắn muốn xóa ảnh này? Hành động không thể hoàn tác.
          </p>
        </div>
        <div className="px-6 py-4 border-t border-gray-200 flex justify-end gap-2">
          <button
            onClick={handleConfirm}
            disabled={isDeleting}
            className="px-4 py-2 bg-red-600 text-white rounded-lg hover:bg-red-700 disabled:opacity-50"
          >
            {isDeleting ? "Đang xóa..." : "Xóa"}
          </button>
          <button
            onClick={onClose}
            disabled={isDeleting}
            className="px-4 py-2 bg-gray-100 text-gray-700 rounded-lg hover:bg-gray-200"
          >
            Hủy
          </button>
        </div>
      </div>
    </div>
  );
}
